import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderContentComponent } from './page-header-content.component';

@NgModule({
  declarations: [PageHeaderContentComponent],
  imports: [
    CommonModule
  ],
  exports: [PageHeaderContentComponent]
})
export class PageHeaderContentModule { }
